import React, { useEffect, useState } from "react";
import { getEngagementActivityList } from "../../helpers/backend_helper";
import { ErrorNotify } from "../../shared/Alert";
import { showLoading } from "react-global-loading";
import "./EngagementActivities.scss";

const formatActivityDate = (value) => {
  if (!value) return "Date unavailable";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleString([], { dateStyle: "medium", timeStyle: "short" });
};

const activityUser = (activity) =>
  activity.userProfile?.fullName || activity.userProfile?.name || "System user";

const EngagementActivities = ({ engagementId, engagementName }) => {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    let isCurrent = true;
    if (!engagementId) return undefined;

    showLoading(true);
    getEngagementActivityList(engagementId)
      .then((response) => {
        if (!isCurrent) return;
        if (response.status) setActivities(response.data || []);
        else
          ErrorNotify(
            response.message || "Unable to load engagement activities."
          );
      })
      .catch(() => {
        if (isCurrent) ErrorNotify("Unable to load engagement activities.");
      })
      .finally(() => showLoading(false));

    return () => {
      isCurrent = false;
    };
  }, [engagementId]);

  return (
    <div className="engagement-activities">
      <p className="engagement-activities__intro">
        Activity recorded for{" "}
        <strong>{engagementName || "this engagement"}</strong>.
      </p>
      {activities.length ? (
        <ol className="engagement-activities__timeline">
          {activities.map((activity) => (
            <li key={activity.id}>
              <span
                className="engagement-activities__marker"
                aria-hidden="true"
              />
              <div>
                <p>
                  {activity.activityNote || "Engagement activity recorded."}
                </p>
                <small>
                  <strong>{activityUser(activity)}</strong> &middot;{" "}
                  {formatActivityDate(activity.activityDate)}
                </small>
              </div>
            </li>
          ))}
        </ol>
      ) : (
        <div className="engagement-activities__empty">
          <i className="bx bx-history" aria-hidden="true" />
          <p>No activity has been recorded for this engagement yet.</p>
        </div>
      )}
    </div>
  );
};

export default EngagementActivities;
